import { createFileRoute } from '@tanstack/react-router';

import {
    type ActionAuditFilters,
    AdminAgentActionsPage,
} from '@apps/web/features/admin_agent_actions';

export const Route = createFileRoute('/_app/admin/agent/actions/')({
    component: ActionAuditIndexRoute,
    validateSearch: (search: Record<string, unknown>): ActionAuditFilters => {
        const stringValue = (key: string): string | undefined => {
            const value = search[key];
            return typeof value === 'string' && value !== ''
                ? value
                : undefined;
        };
        const booleanValue = (key: string): boolean | undefined => {
            const value = search[key];
            return value === 'true' || value === true
                ? true
                : value === 'false' || value === false
                  ? false
                  : undefined;
        };
        const rawPage = search['page'];
        const parsedPage =
            typeof rawPage === 'number'
                ? rawPage
                : typeof rawPage === 'string'
                  ? Number(rawPage)
                  : NaN;
        const page =
            Number.isInteger(parsedPage) && parsedPage >= 1
                ? parsedPage
                : undefined;
        return {
            action_type: stringValue('action_type'),
            target_kind: stringValue('target_kind'),
            target_id: stringValue('target_id'),
            chat_id: stringValue('chat_id'),
            initiator_user_id: stringValue('initiator_user_id'),
            occurred_after: stringValue('occurred_after'),
            occurred_before: stringValue('occurred_before'),
            succeeded: booleanValue('succeeded'),
            include_scheduled: booleanValue('include_scheduled'),
            page,
        };
    },
});

function ActionAuditIndexRoute() {
    return <AdminAgentActionsPage initialFilters={Route.useSearch()} />;
}
